export const FETCHED_DIRECTORY = 'FETCHED_DIRECTORY';

export const UPDATED_DIRECTORY_ITEMS = 'UPDATED_DIRECTORY_ITEMS';

export const UPDATED_SEARCH_TERM = 'UPDATED_SEARCH_TERM';

// secondary type of action via postmessage "payload.action"
// export const IFRAME_MAIN_STATUS = 'IFRAME_MAIN_STATUS';

export const IFRAME_UPDATE_DIRECTORY_DETAILS = 'IFRAME_UPDATE_DIRECTORY_DETAILS';

export const IFRAME_OPEN_DIALOG = 'IFRAME_OPEN_DIALOG';

export const IFRAME_CLOSE_DIALOG = 'IFRAME_CLOSE_DIALOG';

export const IFRAME_MAIN_RESIZE = 'IFRAME_MAIN_RESIZE';

export const IFRAME_STATUS = 'IFRAME_STATUS';

// primary type via postMessage "type"

// send msg to parent to update the status of container
export const READY_STATUS = 'READY_STATUS';
// send msg to main dialog
export const TO_MAIN = 'TO_MAIN';
// send msg to other dialog
export const SEND_TO_DIALOG = 'SEND_TO_DIALOG';
export const RESIZE = 'RESIZE';
export const RELOAD = 'RELOAD';

// types of iframe container "payload.type/payload.sender"
export const LISTING_PAGE_CONTAINER = 'LISTING_PAGE_CONTAINER';
export const DETAILED_PAGE_CONTAINER = 'DETAILED_PAGE_CONTAINER';
export const FILTER_MODAL_CONTAINER = 'FILTER_MODAL_CONTAINER';
export const VFX_MODAL_CONTAINER = 'VFX_MODAL_CONTAINER';
export const HOST_CONTAINER = 'HOST_CONTAINER';
export const DETAIL_MODAL = 'DETAIL_MODAL';
export const LIST_PAGE = 'LIST_PAGE';
export const FILTER_MODAL = 'FILTER_MODAL';
export const VFX_MODAL = 'VFX_MODAL';
export const IMAGE_PREVIEW_MODAL = 'IMAGE_PREVIEW_MODAL';

export const ADMIN_PREVIEW_TAB = '/admin/directories/:directoryId/preview/';

// pagination Constants
export const PAGE_SIZE = 25;
export const PAGE_SIZE_FOR_CARD = 24;

// These are the iframes which are created on top of listing iframe,
// please do not change this variable as it needs to be in sync with almasights
export const EXTRA_IFRAME_CONFIG = [
  {
    containerId: 'details-container',
    iframeId: 'details-iframe',
    triggerType: 'details',
    url: '/d/<object_id>/i/embed/',
  },
  {
    containerId: 'vfx-container',
    iframeId: 'vfx-iframe',
    triggerType: 'vfx',
    url: '/d/<object_id>/vfx/',
  },
  {
    containerId: 'filter-container',
    iframeId: 'filter-iframe',
    triggerType: 'filter',
    url: '/d/<object_id>/f/',
  },
];

// Almasights touchpoints
export const TOUCHPOINTS = {
  VIEWED_DIRECTORY: 'directories-viewed-a-directory',
  VIEWED_DIRECTORY_ITEM: 'directories-viewed-a-directory-item',
  SEARCHED_DIRECTORY: 'directories-searched-directory',
  VIEWED_DIRECTORY_FIELD: 'directories-viewed-a-directory-field',
};

export const LIST_OF_BANNER_IMAGES = [
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_9.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_10.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_11.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_12.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_13.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_14.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_15.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_16.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_17.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_18.png`,
  `${staticPath}img/react-modules/empty-cover-images/empty_cover_19.png`,
];

export const FIELD_ROLES = {
  DATE: 'date',
  TITLE: 'title',
  DESCRIPTION: 'description',
  TAGS: 'tags',
  IMAGE: 'image',
  REGULAR: 'regular',
};

export const FIELD_TYPE = {
  DATE: 'date',
  TEXT: 'text',
  NUMBER: 'number',
  LOCATION: 'location',
  RICH_TEXT: 'rich_text',
  MULTI_TEXT: 'multi_text',
};

// Different filter types
export const SINGLE_SELECT_FILTERS = [FIELD_TYPE.TEXT, FIELD_TYPE.NUMBER, FIELD_TYPE.RICH_TEXT, FIELD_TYPE.MULTI_TEXT];
export const LOCATION_FILTERS = [FIELD_TYPE.LOCATION];
export const DATE_RANGE_FILTERS = [FIELD_TYPE.DATE];

export const FILTER_OPERATIONS = {
  NOT_CONTAINS: 'not_contains',
  CONTAINS: 'contains',
  RANGE: 'range',
  IS_WITH_IN_UPCOMING: 'is_with_in_upcoming',
  IS_WITH_IN_PREVIOUS: 'is_with_in_previous',
};

export const FIELD_TO_FILTER_TYPE = {
  date: 'date',
  text: 'text',
  number: 'text',
  location: 'location',
  rich_text: 'text',
  multi_text: 'text',
};

export const EVENT_DIRECTORY_LABELS = {
  DATE: 'Published On',
  HEADING: 'Heading',
  VENUE: 'Venue',
  IMAGE: 'Image',
  IMAGE_LANDSCAPE: 'Image Landscape',
  IMAGE_PORTRAIT: 'Image Portrait',
  URL: 'Url',
  GUESTS_COUNT: 'Guests Count',
  IS_PAST: 'Is Past',
  VENUE_LINK: 'Venue Link',
  SHOW_GUEST_COUNT: 'Show Guest Count',
};
